module.exports = __webpack_public_path__ + "img/13.cd7e3335.svg";